export default {
      id: "invite-operative-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#invite-operative",
      toString: function () {
        return this.url;
      }
    }